import { ComponentSize } from '../../../types';
import { TypographyType } from '../Typography';

export const EMPTY_STATE_SIZE_CONFIG = {
  [ComponentSize.X_SMALL]: {
    iconSize: ComponentSize.MEDIUM,
    titleType: TypographyType.BASE,
    descriptionType: TypographyType.SMALL,
  },
  [ComponentSize.SMALL]: {
    iconSize: ComponentSize.LARGE,
    titleType: TypographyType.H4,
    descriptionType: TypographyType.BASE,
  },
};
